import { useEffect, useState } from 'react';
import Modal from '../Modal';
import ManualEntryForm from './ManualEntryForm.jsx';
import * as Toast from '../../lib/Toast.js';
import { formatCurrency } from '../../lib/CurrencyHelpers.js';
import { setPaymentHistory } from '../../lib/Queries';
import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import MoneyInput from '../MoneyInput.jsx';
import useDelete from '../../lib/useDelete.jsx';

const EditManualPayment = ({ payment, onUpdate }) => {
    const [showEdit, setShowEdit] = useState(false);
    const { save, isSaving } = useBusinessPostApi(
        `/payments/manual/${payment.id}`,
    );
    const { saveDelete, isDeleting } = useDelete(
        `/payments/manual/${payment.id}/delete`,
    );

    const [amount, setAmount] = useState(null);
    const [notes, setNotes] = useState(null);
    const [method, setMethod] = useState(null);

    useEffect(() => {
        if (showEdit) {
            setAmount(payment.amount);
            setNotes(payment.settings?.notes);
            setMethod(payment.external_id);
        }
    }, [showEdit]);

    function doDelete() {
        saveDelete().then(result => {
            Toast.success(`Deleted ${formatCurrency(amount)} payment`);
            setShowEdit(false);
            if (typeof onUpdate === 'function') {
                onUpdate();
            }
        });
    }

    function submit(ev) {
        ev.preventDefault();
        save({
            method,
            amount,
            notes,
        }).then(result => {
            Toast.success(
                `Successfully updated ${formatCurrency(amount)} payment`,
            );
            setShowEdit(false);
            if (typeof onUpdate === 'function') {
                onUpdate();
            }
            //setPaymentHistory(objectType, objectId, result)
            //onSave();
        });
    }

    return (
        <div className="inline">
            <span className="mx-1">&middot;</span>
            <a
                href="#"
                className="no-underline"
                onClick={e => {
                    e.preventDefault();
                    setShowEdit(true);
                }}
            >
                Edit
            </a>

            <Modal isOpen={showEdit} onClose={() => setShowEdit(false)}>
                <form onSubmit={submit}>
                    <MoneyInput
                        label="amount"
                        value={amount}
                        onChange={setAmount}
                        className="mb-4"
                    />
                    {!!method && (
                        <ManualEntryForm
                            method={method}
                            setMethod={setMethod}
                            notes={notes}
                            setNotes={setNotes}
                        />
                    )}

                    <div className="flex items-center space-x-6 mt-4">
                        <button type="submit" className="btn-save">
                            {isSaving ? 'Saving...' : 'Save'}
                        </button>

                        <button
                            type="button"
                            className="btn-pink-pill-lg"
                            onClick={doDelete}
                        >
                            Delete
                        </button>
                    </div>
                </form>
            </Modal>
        </div>
    );
};

export default EditManualPayment;
